<template>
  <BContainer
    v-if="currentUser"
    class="mb-4"
  >
    <div class="d-flex justify-content-end">
      <BBreadcrumb
        v-if="$route.meta.breadcrumb"
        :items="$route.meta.breadcrumb || []"
      />
    </div>

    <BNav
      class="scrollable-x-tabs no-scrollbar nav-memos-tabs"
      pills
    >
      <div class="nav-item">
        <div
          class="d-flex align-items-center position-absolute"
          style="padding: 2px 1px; height: 38px;"
        >
          <i
            class="fas fa-chevron-left bg-primary-light p-1 rounded-lg"
            style="font-size: 20px;"
          />
        </div>
      </div>

      <BNavItem
        :active="getActiveRoute('memos')"
        :to="{
          name: 'rsm.memos'
        }"
      >
        <i :class="iconState('fa-file-circle-question', getActiveRoute('memos'))" /> Memos
      </BNavItem>

      <BNavItem
        :active="getActiveRoute('signed-memos')"
        :to="{
          name: 'rsm.memos.signed-memos'
        }"
      >
        <i :class="iconState('fa-file-chart-column', getActiveRoute('signed-memos'))" /> Signed Memos
      </BNavItem>

      <div class="nav-item">
        <div
          class="d-flex align-items-center position-absolute"
          style="right: 20px; padding: 2px 1px; height: 38px;"
        >
          <i
            class="fas fa-chevron-right bg-primary-light p-1 rounded-lg"
            style="font-size: 20px;"
          />
        </div>
      </div>
    </BNav>

    <div class="py-2">
      <RouterView
        ref="tableView"
      />
    </div>
  </BContainer>
</template>
<script>
import { mapGetters } from 'vuex'
import MxMisc from '@/mixins/misc'

export default {
  name: 'Memos',

  mixins: [
    MxMisc
  ],

  middleware: [
    'auth',
    'rsm'
  ],

  computed: {
    ...mapGetters({
      currentUser: 'auth/user'
    })
  },

  mounted () {
    if (this.currentUser) {
      this.$nextTick(() => {
        this.attachArrowScroller('.nav-memos-tabs')
      })
    }
  },

  beforeDestroy () {
    this.detachArrowScroller('.nav-memos-tabs')
  },

  methods: {
    getTabRoute (tabName) {
      return `/rsm/${tabName}`
    },

    getActiveRoute (tabName) {
      return this.$route.path === this.getTabRoute(tabName)
    }
  }
}
</script>
